import admin from './admin';
import setting from './setting';

export default {admin, setting};
